// Engine constants - mirror of the C++ MetronomeEngine (keep in sync with the
// Android app so patterns, presets and behaviour stay interchangeable).

export const MAX_BEATS = 16;            // measure capacity
export const MAX_TICKS_PER_BEAT = 8;    // step-pattern stride (up to 32nds)
export const SLOTS_PER_BEAT = 8;
export const PATTERN_SLOTS = MAX_BEATS * SLOTS_PER_BEAT; // 128 positional slots
export const ACCENT_PITCH = 1.35;

// Step levels inside patterns.
export const LEVEL_MUTE = 0;
export const LEVEL_NORMAL = 1;
export const LEVEL_ACCENT = 2;
export const LEVEL_SECONDARY = 3;       // lighter accent (e.g. beat 4 of 3+2)

// Voice slots: separate sound + mixer gain per rhythmic role.
export const VOICE_ACCENT = 0;
export const VOICE_BEAT = 1;
export const VOICE_SUB = 2;

// Polyrhythm mode.
export const MAX_POLY_RINGS = 4;
export const MAX_POLY_STEPS = 16;
export const MIN_POLY_PITCH = 0.25;
export const MAX_POLY_PITCH = 4.0;
export const POLY_PITCH_RANGE_SEMIS = 24;

// Step sequencer mode.
export const MAX_SEQ_TRACKS = 24;
export const MAX_SEQ_STEPS = 16;
export const SEQ_STEPS_PER_UNIT = 4;    // a step is a 16th of the BPM note
export const SEQ_NORMAL_GAIN = 0.72;    // normal-step velocity vs. accent
export const MAX_SAMPLE_SLOTS = 24;

// Sequencer mastering bus.
export const SEQ_COMP_MAX_THRESH_DB = -16.0;
export const SEQ_COMP_MAKEUP_SHARE = 0.55;
export const SEQ_COMP_ATTACK_SEC = 0.004;
export const SEQ_COMP_RELEASE_SEC = 0.110;
export const SEQ_CLIP_KNEE = 0.75;
export const RVB_COMB_MS = [17.8, 19.0, 20.4, 21.6] as const;
export const RVB_COMB_FEEDBACK = 0.70;
export const RVB_COMB_DAMP = 0.35;
export const RVB_AP_MS = [5.0, 1.7] as const;
export const RVB_AP_GAIN = 0.5;
export const RVB_PREDELAY_MS = 10.0;
export const RVB_WET_SCALE = 1.6;

// Declick fade: ~2 ms at 48 kHz.
export const FADE_STEP = 1.0 / 96.0;
// Longest click voice the engine keeps a scale-copy of.
export const MAX_VOICE_SECONDS = 0.5;

/** Rational tanh approximation (Padé 3/2), input pre-clamped to [-3, 3]. */
export function tanhApprox(x: number): number {
  const x2 = x * x;
  return (x * (27 + x2)) / (27 + 9 * x2);
}
